export default __webpack_public_path__ + "static/membership-current-promo-ed5ebc51d13be0a3251cdec362ce332e.jpg";